module.exports = __webpack_public_path__ + "assets/img/experts-1.ad729042.png";